import { Component, HostListener } from '@angular/core';
import { IdentityStorage } from 'storage-service-lib';
import { environment } from '../../../environments/environment';
import { DebugService } from '../../services/debug.service';

@Component({
  selector: 'app-debugging',
  templateUrl: './debugging.component.html',
  standalone: false,
})
export class DebuggingComponent {
  enableDebugging = environment.isDev;
  showDebugLinks = false;

  constructor(private debugService: DebugService, private identityStorage: IdentityStorage) {}

  async dumpObjectAtSelection(): Promise<unknown> {
    return Word.run(async (context) => {
      await this.debugService.dumpObjectAtSelection(context);
    });
  }

  async dumpModel(): Promise<unknown> {
    return Word.run(async (context) => {
      await this.debugService.dumpModel(context, this.identityStorage.get()?.namespace);
    });
  }

  async dumpAddInInfo(): Promise<unknown> {
    return Word.run(async (context) => {
      await this.debugService.dumpAddInInfo(context);
    });
  }

  async dumpContentControls(): Promise<unknown> {
    return Word.run(async (context) => {
      await this.debugService.dumpContentControls(context);
    });
  }

  toggleDebugPanel() {
    this.debugService.toggleDebugPanel();
  }

  @HostListener('document:keydown.alt.d', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {
    this.enableDebugging = environment.isDev && !this.enableDebugging;
  }
}
